export default [
  { value: 'AC', title: 'Acre' },
  { value: 'AL', title: 'Alagoas' },
  { value: 'AP', title: 'Amapá' },
  { value: 'AM', title: 'Amazonas' },
  { value: 'BA', title: 'Bahia' },
  { value: 'CE', title: 'Ceará' },
  { value: 'DF', title: 'Distrito Federal' },
  { value: 'ES', title: 'Espírito Santo' },
  { value: 'GO', title: 'Goiás' },
  { value: 'MA', title: 'Maranhão' },
  { value: 'MT', title: 'Mato Grosso' },
  { value: 'MS', title: 'Mato Grosso do Sul' },
  { value: 'MG', title: 'Minas Gerais' },
  { value: 'PA', title: 'Pará' },
  { value: 'PB', title: 'Paraíba' },
  { value: 'PR', title: 'Paraná' },
  { value: 'PE', title: 'Pernambuco' },
  { value: 'PI', title: 'Piauí' },
  { value: 'RJ', title: 'Rio de Janeiro' },
  { value: 'RN', title: 'Rio Grande do Norte' },
  { value: 'RS', title: 'Rio Grande do Sul' },
  { value: 'RO', title: 'Rondônia' },
  { value: 'RR', title: 'Roraima' },
  { value: 'SC', title: 'Santa Catarina' },
  { value: 'SP', title: 'São Paulo' },
  { value: 'SE', title: 'Sergipe' },
  { value: 'TO', title: 'Tocantins' }
]
